import { createAction } from '@reduxjs/toolkit';

/** Leaf logout action — safe to import from other slices without pulling auth-api. */
export const logout = createAction('auth/logout');
